import clsx from 'clsx';
import { QuestionMarkIcon, TokenIcons } from '../../../assets/icons';
import Card from '../../../components/Card';
import ExternalLink from '../../../components/ExternalLink';
import InfoPopUp from '../../../components/InfoPopUp';
import { LiquidityPoolType } from '../../../context/pool/poolTypes';
import usePoolState from '../../../context/pool/usePoolState';
import { formatAmountWithSuffix, formatPercentages, formatUSD } from '../../../helpers';
// import useHistoricalLockedPoolLiquidity from '../../../hooks/analytics/useHistoricalLockedPoolLiquidity';
import useMockHistoricalLockedPoolLiquidity from '../../../hooks/analytics/useMockHistoricalLockedPoolLiquidity';
// import Button from '../../../components/Button';

type PoolOptionProps = {
    pool: LiquidityPoolType;
};

const PoolOption: React.FC<PoolOptionProps> = ({ pool }) => {
    const {
        selectedLiquidityPool: selectedPool,
        setSelectedLiquidityPool: setSelectedPool,
    } = usePoolState();

    const { historicalLockedPoolLiquidity } = useMockHistoricalLockedPoolLiquidity(
        selectedPool?.poolId || '',
        '1d'
    );

    // const { historicalLockedPoolLiquidity } = useHistoricalLockedPoolLiquidity(
    //     pool.poolId,
    //     '1d'
    // );

    const tvl = historicalLockedPoolLiquidity
        ? historicalLockedPoolLiquidity[historicalLockedPoolLiquidity.length - 1].value
        : undefined;

    return (
        <Card
            className={clsx('pool-option', {
                active: selectedPool?.poolId === pool.poolId,
            })}
            onClick={() => setSelectedPool(pool)}
        >
            <div className='pool-selector-label'>
                <div className='icon'>{TokenIcons[pool.lpToken]}</div>
                <div className='lp-price'>
                    <div className='title'>
                        {pool.lpToken}{' '}
                        <InfoPopUp clickable trigger={<QuestionMarkIcon />}>
                            <ExternalLink to={pool.docs}>
                                {pool.name.split(' ')[0]} Docs
                            </ExternalLink>
                        </InfoPopUp>
                    </div>
                    <div className='value'>
                        {formatUSD(pool.isZeroPrice ? '1' : pool.currentPriceEstimate, {
                            minDecimals: 2,
                        })}
                    </div>
                </div>
            </div>
            <div className='apr'>
                <div className='title'>APR</div>
                <div className='value'>{formatPercentages(pool.apr)}%</div>
            </div>
            <div className='tvl'>
                <div className='title'>TVL</div>
                <div className='value'>
                    {tvl !== undefined
                        ? formatAmountWithSuffix(tvl, {
                              currency: 'USD',
                              minDecimals: 2,
                              minValue: 10_000,
                          })
                        : '-'}
                </div>
            </div>
            {/* <Button
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) => e.stopPropagation()}
                externalLink={pool.docs}
            >
                {pool.name.split(' ')[0]} Docs
            </Button> */}
        </Card>
    );
};
export default PoolOption;
